import React from "react";

export default function Footer() {
  return (
    <footer>
     <p>© 2023 Tolea AG. All rights reseved</p>
     <span>answers in console</span>
    </footer>
  );
}
